import Apps from "../container/emailPassModal";

function EmailPass(){

    return(
        
            <div className="cont">
            <Apps />
            {/* <AiOutlineMail style={{width:'10%', height:'22px'}} />
             Continue with Email and Password */}
            </div>

    )
}
export default EmailPass;